import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { Guest } from '../../../models/guest';
import { GuestService } from '../services/guest.service';

@Component({
    selector: 'app-guest-list',
    templateUrl: './guest-list.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class GuestListComponent {
	public readonly guests = input<Guest[]>();
	public readonly selectedGuestId = input<number>();

	public readonly guestSelected = output<string>();

	guestsList: any[] = [];
	guest: any = {};

	constructor(private readonly guestService: GuestService) {}

	getGuestStatus(guest: any) {
		return this.guestService.isGuestDetailComplete(guest) ? 'complete' : 'started';
	}

	getGuestDisabled(guests: any, index: any) {
		let disable = false;
		for (let i = 0; i < index; i++) {
			if (this.getGuestStatus(guests[i]) !== 'complete') {
				disable = true;
			}
		}
		return disable;
	}

	selectGuest(guestId: any) {
		this.guestSelected.emit(guestId);
	}

	capitalizeFirstLetter(string: any) {
		if (string.length === 0) {
			return '';
		}

		string = string.toLowerCase();
		return string.charAt(0).toUpperCase() + string.slice(1);
	}

	isCurrent(guest: Guest) {
		return guest.guestId === this.selectedGuestId();
	}
}
